/** Media download preferences — H5 Wi-Fi-only default (SEC-MED / privacy). */

export interface MediaPrefs {
  /** When true, auto-download attachments only on Wi-Fi / ethernet (default true). */
  wifiOnlyAutoDownload: boolean;
}

const KEY = "veto.media.prefs";

export function loadMediaPrefs(): MediaPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { wifiOnlyAutoDownload: true };
    const parsed = JSON.parse(raw) as Partial<MediaPrefs>;
    return {
      wifiOnlyAutoDownload: parsed.wifiOnlyAutoDownload !== false,
    };
  } catch {
    return { wifiOnlyAutoDownload: true };
  }
}

export function saveMediaPrefs(prefs: MediaPrefs): void {
  localStorage.setItem(KEY, JSON.stringify(prefs));
}

/** Best-effort network type; assume metered/cellular when unknown on mobile. */
export function shouldAutoDownload(prefs: MediaPrefs = loadMediaPrefs()): boolean {
  if (!prefs.wifiOnlyAutoDownload) return true;
  const conn = (navigator as Navigator & {
    connection?: { type?: string; effectiveType?: string; saveData?: boolean };
  }).connection;
  if (!conn) return true; // desktop / unknown — allow
  if (conn.saveData) return false;
  if (conn.type === "cellular") return false;
  if (conn.effectiveType === "slow-2g" || conn.effectiveType === "2g") return false;
  return true;
}
